import React, { useState } from "react";
import axios from "axios";
import {
  Container,
  Content,
  ContactDetails,
  Logo,
  Info,
  SocialIcons,
  Form,
  InputRow,
  InputWrapper,
  Label,
  Input,
  TextArea,
  SubmitButton,
} from "../styles/ContactUs.style";
import ImageContact from "../assets/image-contact.png";
import { IoLogoWhatsapp } from "react-icons/io";
import { BiLogoInstagramAlt } from "react-icons/bi";
import { FaFacebookF } from "react-icons/fa";
import HeaderSection from "../components/HeaderSection/HeaderSection";

const ContactUsPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.email || !formData.name) {
      alert("Por favor complete los campos requeridos");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/contact`, formData);
      
      if (response.data.success) {
        // Clear the form
        setFormData({
          name: "",
          phone: "",
          email: "",
          message: ""
        });
        alert(response.data.message);
      } else {
        alert("Hubo un error al enviar el formulario. Por favor intente nuevamente.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Hubo un error al procesar el formulario. Por favor intente nuevamente.");
    }
    setIsSubmitting(false);
  };

  return (
    <Container>
      <HeaderSection title={"Contacto"} subtitle={"Contáctanos"} />
      <Content>
        <ContactDetails>
          <Logo>
            <img src={ImageContact} alt="Contact" />
          </Logo>
          <Info>
            <p>Datos de contacto</p>
            <p>11 Avenida 15-11 Zona 10, Guatemala C.A</p>
            <p>PBX: (+502) 2504 8585</p>
          </Info>
          <SocialIcons>
            <IoLogoWhatsapp />
            <BiLogoInstagramAlt />
            <FaFacebookF />
          </SocialIcons>
        </ContactDetails>
        <Form onSubmit={handleSubmit}>
          <InputRow>
            <InputWrapper>
              <Label>NOMBRE</Label>
              <Input 
                type="text" 
                name="name"
                placeholder="Nombre:" 
                value={formData.name}
                onChange={handleChange}
                required
              />
            </InputWrapper>
            <InputWrapper>
              <Label>TELÉFONO</Label>
              <Input 
                type="text" 
                name="phone"
                placeholder="Teléfono:" 
                value={formData.phone}
                onChange={handleChange}
              />
            </InputWrapper>
          </InputRow>
          <InputWrapper>
            <Label>CORREO</Label>
            <Input 
              type="email" 
              name="email"
              placeholder="Correo electrónico:" 
              value={formData.email}
              onChange={handleChange}
              required
            />
          </InputWrapper>
          <InputWrapper>
            <Label>MENSAJE</Label>
            <TextArea 
              name="message"
              placeholder="Escribe tu mensaje:" 
              value={formData.message}
              onChange={handleChange}
            />
          </InputWrapper>
          <SubmitButton type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Enviando..." : "Enviar"}
          </SubmitButton>
        </Form>
      </Content>
    </Container>
  );
};

export default ContactUsPage;
